// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","manageCookiesButton":"gcIW9","backButton":"_31QZs","arrow":"_2THXn"};